import { Button } from 'react-bootstrap';
import React from 'react';
import PageHoc from '../../HoC/PageHoC';

const Login = (props) => {
    const onClick = () => {
        props.history.push("/home");
    }
    return (
        <div className="loginbox">
            <div className="loginTitle">
                <h1>SharePoint Site Creator</h1>
                <p>
                    Hello and welcome to the SharePoint Site creator, here you will be designing your ideal SharePoint site!
                </p>
                <Button size="lg" variant="primary" className="Button" onClick={onClick}>Start your SharePoint Journey</Button>
            </div>
        </div>
    );
}

export default PageHoc(Login);


// WEBPACK FOOTER //
// ./src/components/login/login.js